import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { FiltersService } from '../app/services/filters.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {
  //title = 'postOffMap';
  public datePostIndex = undefined;

  constructor( 
    private titleService: Title,
    private metaService: Meta,
    private activatedRoute: ActivatedRoute,
    private filtersService: FiltersService,
     ) {

    }

  ngOnInit() {
    this.titleService.setTitle('Пошук відділень | Укрпошта');   
    this.metaService.updateTag({ property: 'og:type', content: 'website' });
    this.metaService.updateTag({ property: 'og:image', content: 'https://offices.ukrposhta.ua/assets/og-logo.png' });
    this.metaService.updateTag({ property: 'og:site_name', content: 'Ukrposhta' });


    this.metaService.updateTag({ property: 'og:title', content: 'Пошук відділень | Укрпошта' });
    this.metaService.updateTag({ property: 'og:description', content: 'Сервіс пошуку індексів і відділень Укрпошти по всій території України.' });
    this.metaService.updateTag({ property: 'og:url', content: 'https://offices.ukrposhta.ua/' });

    this.activatedRoute.queryParams.subscribe(params => {
      let datePostIndex = params['postIndex'];
      if (datePostIndex == undefined){
      } else {
        this.titleService.setTitle('Пошук відділень ' + datePostIndex +' | Укрпошта');
        this.metaService.updateTag({ name: 'description', content: 'Сервіс пошуку індексів '+ datePostIndex + ' і відділень Укрпошти по всій території України.' });
        this.metaService.updateTag({ name: 'keywords', content: datePostIndex + ', укрпошта індекси, індекс, поштові індекси, індекси укрпошта, індекси, укрпошта індекс, індекс укрпошта, поштовий індекс, індекси україни, поштові індекси укрпошта, індекс київ, індекси києва, укрпошта індекси, індекс, поштові індекси, індекси укрпошта, індекси, укрпошта індекс, індекс укрпошта, поштовий індекс, індекси україни, поштові індекси укрпошта' });
        this.metaService.updateTag({ property: 'og:title', content: 'Пошук відділень ' + datePostIndex +' | Укрпошта' });
        this.metaService.updateTag({ property: 'og:description', content: 'Сервіс пошуку індексів '+ datePostIndex + ' і відділень Укрпошти по всій території України.' });
      }
    });
    this.activatedRoute.queryParams.subscribe(params => {
      let datePostCity = params['postCity'];
      if (datePostCity == undefined){
      } else {
        this.titleService.setTitle('Пошук відділень ' + datePostCity +' | Укрпошта');
        this.metaService.updateTag({ name: 'description', content: 'Сервіс пошуку індексів і відділень '+ datePostCity + ' Укрпошти по всій території України.' });
        this.metaService.updateTag({ name: 'keywords', content: datePostCity + ', укрпошта індекси, індекс, поштові індекси, індекси укрпошта, індекси, укрпошта індекс, індекс укрпошта, поштовий індекс, індекси україни, поштові індекси укрпошта, індекс київ, індекси києва, укрпошта індекси, індекс, поштові індекси, індекси укрпошта, індекси, укрпошта індекс, індекс укрпошта, поштовий індекс, індекси україни, поштові індекси укрпошта' });
        this.metaService.updateTag({ property: 'og:title', content: 'Пошук відділень ' + datePostCity +' | Укрпошта' });
        this.metaService.updateTag({ property: 'og:description', content: 'Сервіс пошуку індексів і відділень '+ datePostCity + ' Укрпошти по всій території України.' });
      }
    });
    this.activatedRoute.queryParams.subscribe(params => {
      const type = params['type'];
      const postCity = params['postCity'];

      if (type) {
        this.filtersService.setFilterState(type, true);
        this.filtersService.setSelectedFreight(type);
        
        const titleBase = (type === 'shippedFreightPm') ? 'Поштомати' : 'Точки видачі';
        this.titleService.setTitle(postCity ? `${titleBase} ${postCity} | Укрпошта` : `${titleBase} по всій Україні`);
      }

      if (type || postCity) {
        setTimeout(() => {
          const mapElement = document.getElementById('map');
          if (mapElement) {
            const elementPosition = mapElement.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - 70;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }, 800); // Трохи більша затримка, щоб впевнитись, що карта почала рендеритись
      }
    });
  }
}
